import { z } from "zod"

export const PauseDtoSchema = z.object({
  pausedAt: z.string().datetime(),
  resumeAt: z.string().datetime().nullable(),
  programAccessAllowed: z.boolean(),
})

export const PauseInputDtoSchema = z.object({
  durationInMonths: z.number().nullable(),
  programAccessAllowed: z.boolean().default(true),
})

export type PauseDto = z.infer<typeof PauseDtoSchema>
export type PauseInputDto = z.infer<typeof PauseInputDtoSchema>
